// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".patron-profile-material-info{position:relative}.patron-profile-material-info--attributes{width:calc(100% - 60px)}.patron-profile-material-info--attribute{grid-template-columns:1fr 2fr}.patron-profile-material-info--checkbox{position:absolute;right:0;top:calc(50% - 18px)}", ""]);
// Exports
module.exports = exports;
